<template>
	<div id="usuario-cuenta-saldo">

		<b-card class="mb-3 p-2" v-if="!justIndex" no-body>
			<div class="flex">
				<b-button-group size="xs">
					<b-button variant="black" @click="displayForm()">
						Registrar SIM
					</b-button>
					<b-button variant="primary" @click="$router.push('/' + contrataYaURI)">
						{{ generalTitle }}
					</b-button>
				</b-button-group>
			</div>
		</b-card>

		<template v-if="cNumerosFiltered.length">
			<filters-handler class="filters-handler" v-model="filterCfg" :items-count="cNumerosFiltered.length" :per-page="perPage" />
			<numero-blackfon v-for="(item, $index) in cNumerosPaginated" :key="('cNumerosPaginated-' + $index + '-' + item.id + '-' + filterCfg.page)"
				:item="item"
				:selected-item="selectedItem"
				:autoclick="(filterCfg.page == 1 && $index == 0 && !justIndex)"
				:justIndex="justIndex"
				@handleMsisdn="handleMSISDN" />
		</template>

		<template v-else>
			<slot name="no-numeros"></slot>
		</template>

		<!-- MODALS -->
		<ui-modal v-model="showingAddingModal" size="small">

			<div slot="header">
				Agrega un número BlackFon
			</div>

			<div slot="footer" v-if="!isProcessing">
				<button class="dimmed" @click="showingAddingModal = 0">
					Cancelar
				</button>
				<button @click="tryToLink()">
					Aplicar
				</button>
			</div>

			<div slot="footer" v-else>
				<button variant="outline" disabled> Procesando... </button>
			</div>

			<div id="formBody" class="p-3">
				<b-form @submit.prevent>

					<b-input-group prepend="Teléfono">
						<b-form-input v-model="form.msisdn" id="msisdn" />
					</b-input-group>

					<b-input-group class="mt-3" prepend="PIN" v-if="!!form.id">
						<b-form-input v-model="form.pin" type="numeric" pattern="^\d{3,6}$" :maxlength="6"
							:minlength="3" placeholder="PIN (3-6 dígitos)"
							@input="form.pin = form.pin.replace(/[^0-9]/g, '').slice(0, 6)" />
					</b-input-group>

				</b-form>
			</div>

		</ui-modal>

		<msisdnOverview ref="msisdnOverview" @refresh="forceReload" />
		<suscription-handler ref="suscriptionHandler" @success="forceReload" />
	</div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import { notify } from '@/js/utils.js'
import { mapActions } from 'vuex';
import { portalCautivo as portalCautivoOpener } from '@/js/apiConfig'

// DANIEL
import UiModal from '@@/ui-modal'
import ventasEsim from '@@/ventas-esim.vue'
import contrataYa from '@@/contrata-ya/contrataYa.js'
import suscriptionHandler from '@@/suscripciones/suscriptionHandler.vue';
import filtersHandler from '@@/filtersHandler.vue';

// RELATIVES
import AccountMsisdn from './account-msisdn.vue';
import msisdnOverview from './msisdn-overview.vue';
import numeroBlackfon from './numero-blackfon.vue';

const bTable = 'bTable',
	toggleList = 'toggleList';

let formArchetype = {
	msisdn: null,
	id: null,
	pin: null
}

export default {
	components: {
		UiModal,
		// accountSaldoPage,
		AccountMsisdn,
		msisdnOverview,
		suscriptionHandler,
		ventasEsim,
		filtersHandler,
		numeroBlackfon
	},
	props: {
		indexURI: {
			type: String,
			default: 'skyaccount/getmine'
		},
		suscriptionId: {
			type: String,
			default: 'any'
		},
		justIndex: {
			type: Boolean,
			default: false
		},
		// hideEstatusDN: {
		// 	type: Boolean,
		// 	default: true
		// },
		allowMobiPhone: {
			type: Boolean,
			default: false
		},
		generalTitle: {
			type: String,
			default: contrataYa.generalTitle
		},
		contrataYaURI: {
			type: String,
			default: contrataYa.URI
		},
		// mode: {
		// 	type: String,
		// 	default: toggleList // bTable, toggleList
		// },
		perPage: {
			type: Number,
			default: 5
		},
		fieldsProp: {
			type: Array,
			default: () => {
				return [
					'alias',
					{ key: 'msisdn', label: 'Número' },
					{ key: 'planName', label: 'Plan' },
					'precio',
					{ key: 'estatus_suscripcion', label: 'Suscripción' }
				]
			}
		}
	},
	data: () => {
		return {
			selectedItem: null,
			mobi: {
				instance: null,
				instancePIN: null
			},
			isLoading: false,
			isProcessing: false,
			showingAddingModal: false,
			form: _.clone(formArchetype),
			lineas: [],
			filterCfg: {
				term: '',
				page: 1,
				args: {}
			},
			bTable, toggleList
		}
	},
	computed: {
		cNumerosPaginated() {
			const start = (this.filterCfg.page - 1) * this.perPage;
			const end = start + this.perPage;
			return this.cNumerosFiltered.slice(start, end);
		},
		cNumerosFiltered() {
			return this.lineas.filter(item => {
				if (!this.filterCfg.term) return true;
				const term = this.filterCfg.term.toLowerCase();
				return (
					(item.msisdn && item.msisdn.toString().includes(term)) ||
					(item.alias && item.alias.toLowerCase().includes(term)) ||
					(item.planName && item.planName.toLowerCase().includes(term))
				);
			});
		}
	},
	methods: {
		...mapActions([
			'skyaccountTryToLinkNumber'
		]),
		portalCautivo(item) {
			portalCautivoOpener(item.msisdn)
		},
		handleMSISDN(item) {
			console.log('handleMSISDN', item);
			if (item.stripe_suscripcion_id || parseInt(item.byPass))
				this.$refs.msisdnOverview.open(item);
			else if (item.estatus_msisdn != 'Descartado')
				this.$refs.suscriptionHandler.showModal(item);
		},
		displayForm() {
			this.showingAddingModal = true;
		},
		async skyaccountUpdate() {
			try {
				// RESPONSE
				let response = await axios.get(`${this.indexURI}/${this.suscriptionId}`)

				// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
				if (response.msg)
					notify(response.msg, response.class || 'info')

				// RESPONSE PROCESSING
				if (response.status) 
					this.lineas = response.data.numerosblackfon
				
			} catch (e) {
				console.error(e)
				notify(e)
			}
		},
		async tryToLink() {
			this.isProcessing = true
			try {
				let response = await this.skyaccountTryToLinkNumber(this.form)
				if (response.status && !!response.data && !!response.data.id) {
					this.form.id = response.data.id
				}
				else if (response.status) {
					await this.loadUp()
					this.showingAddingModal = false
				}
			} catch (e) {
				console.error(e)
				notify(e)
			}
			this.isProcessing = false
		},
		async loadUp() {
			await this.skyaccountUpdate()
		},
		async forceReload() {
			this.isLoading = true;
			await this.loadUp()
			this.isLoading = false;
		}
	},
	async beforeMount() {
		await this.forceReload()
	},
	watch: {
		'form.id'() {
		},
		showingAddingModal() {
			if (!this.showingAddingModal) {
				this.form = _.clone(formArchetype)
			}
		}
	}
}
</script>

<style lang="scss">
@import '../../../../sass/utils/_variables.scss';

#usuario-cuenta-saldo {

	.flex {
		display: flex;
		flex-flow: row nowrap;
		gap: 1em;
		align-items: center;
		justify-content: center;
		justify-content: end
	}

	.alias {
		color: $secondary;
		display: block;
	}

	.plan-name {
		display: block;
		font-size: calc(1em / 1.618);
	}

	.usuario-numeroblackfon {
		display: flex;
		flex-flow: row-reverse;
		justify-content: center;

		// align-items: center;
	}

	.descartado {

		&,
		strong {
			text-transform: uppercase;
			color: $colPrimary !important;
		}

		small {
			color: $colPrimary !important;
		}
	}

	.uppercase {
		text-transform: uppercase;
	}

	.unsuscribed {
		color: $accent;
		color: $secondary;
		text-transform: uppercase;
		font-weight: bold;
		font-weight: 0.8em;
	}

	tr {
		cursor: pointer;

		td {
			line-height: 1.0em;
		}
	}

	small {
		font-size: 0.5em;
		color: $accent-dark;
	}

	strong {
		color: $accent;
		font-size: 1.2em;
	}

	.btn.toggler.btn-black {
		background-color: $black;
		color: $accent;
	}

	.filters-handler {
		margin: 0;
	}
}
</style>